import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Form, Input, message } from "antd";
import UploadAvatar from "../Signup/uploadAvatar";
import { Parse } from "parse";
import Phone from "react-phone-number-input";
import "react-phone-number-input/rrui.css";
import "react-phone-number-input/style.css";
import { submitForm } from "../Actions/profileActionCreators";


const FormItem = Form.Item;
const { TextArea } = Input;

class SettingsProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      desc: null,
      phone: null,
      adresse: null,
      avatar: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeAdresse = this.onChangeAdresse.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
    this.onChangeDesc = this.onChangeDesc.bind(this);
  }

  handleSubmit = e => {
  e.preventDefault();
		this.props.form.validateFields(async (error, values) => {
			if (error) {
				message.error("Problème lors de la modification");
			} else {
				await this.props.submitForm(values);
        message.success("Profil enregistré !");
			}
		});
  };

  onChangeAvatar = file => {
    this.props.form.setFieldsValue({ picture: file });
  };

  onChangeAdresse = e => {
    this.setState({ adresse: e });
    this.props.form.setFieldsValue({ desc: this.state.adresse });
  };

  onChangePhone = e => {
    this.setState({ phone: e });
    this.props.form.setFieldsValue({ phone: e });
  };

  onChangeDesc = e => {
    this.setState({ desc: e });
    this.props.form.setFieldsValue({ desc: this.state.desc });
  };

  render() {
    var attributes = Parse.User.current().attributes;

    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    };

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem {...formItemLayout} label="Votre pseudo">
          {getFieldDecorator("nickName", {
            rules: [
              {
                required: true,
                message: "Merci d'indiquer un pseudo"
              }
            ],
            onChange: this.props.onChangeNickName,
            initialValue: attributes.nickName
          })(<Input maxLength="38"/>)}
        </FormItem>
        <FormItem {...formItemLayout}
        label= 'Votre photo'>
          {getFieldDecorator("picture", {
            rules: [{ required: true }]
          })(<UploadAvatar onChange={this.onChangeAvatar}></UploadAvatar>)}
        </FormItem>
        <FormItem {...formItemLayout} label="Adresse postale">
          {getFieldDecorator("adresse", {
            rules: [
              {
                required: true,
                message: "Veuillez entrer votre adresse postale"
              }
            ],
            onChange: this.props.onChangeAdresse,
            initialValue: attributes.adresse
          })(<Input />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Téléphone">
          {getFieldDecorator("phone", {
            rules: [
              {
                required: true,
                message: "Veuillez entrer votre numéro de téléphone"
              }
            ],
            initialValue: attributes.phone
          })(
            <Phone
              className="ant-input"
              placeholder="Votre numéro de téléphone"
              onChange={this.onChangePhone}
            />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Votre description">
          {getFieldDecorator("desc", {
            rules: [
              { required: true, message: "Veuillez entrer votre description" }
            ],
            initialValue: attributes.desc,
            onChange: this.onChangeDesc
          })(<TextArea rows={3} />)}
        </FormItem>
        <Button
          style={{ marginLeft: "8px", marginTop: "5px", marginBottom: "25px" }}
          type="primary"
          htmltype="submit"
          onClick={this.handleSubmit}
        >
          Enregistrer
        </Button>
      </Form>
    );
  }
}

function saveProfile(values) {
	// The user was retrieved successfully.

	var currentUser = Parse.User.current();

	var sessionToken = currentUser.getSessionToken();
	Parse.User.become(sessionToken).then(function(user) {
    user.set("nickName", values.nickName);
		user.set("adresse", values.adresse);
		user.set("phone", values.phone);
		user.set("avatar", values.picture);
		user.set("description", values.description);

		user.save(null, {
			success: function(user) {
        //console.log("sauvegarde OP")
			},

			error: function(user, error) {

				message.error(error.message);
			}
		});
	});
}


const mapStateToProps = ({user}) => user;

const mapDispatchToProps = dispatch => {
	return {
		submitForm: values => {
			saveProfile(values);
			dispatch(submitForm(values));
		}
  }
}

const connectedSettingsProfile = Form.create()(SettingsProfile);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectedSettingsProfile);
